import React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';
import TileGroup from './TileGroup';
import SingleSite from './SingleSite';

const MyGroups = ({ groups }) => {

    const groupStatuses = [
        {
            id: 1,
            status: 'Active',
            label: 'Active'
        }
    ]

    const groupsToDisplay = groupStatuses.map(x=> 
        <TileGroup  
            key={x.id}
            groupBy={x.label} 
            elements={groups.filter(group => (group.siteStatus === x.status)).map(s =>
                <SingleSite
                    key={s.id}
                    site={s}
                />)}
        />)

    return(
        <div>
            <MessageBar messageBarType={MessageBarType.info}>
                <span>
                    Note: This view shows only Microsoft 365 Groups with stored files (more than 1 file). Groups without content are not displayed, for list of all Groups click<a href="https://myaccount.microsoft.com/groups/groups-i-own" target="_blank" rel="noopener noreferrer">here</a>.
                </span>
            </MessageBar>

            {groupsToDisplay}
        </div>
    );
}

export default MyGroups


// WEBPACK FOOTER //
// ./src/components/ManageCenter/MyGroups.js